export enum BookingDialogView {
  List,
  Flow,
  Journey
}
